// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/WikiLies.js
//  WikiLies
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useRef, useState } from "react";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { wikiApi } from "./api";
import { wCat } from "./constantes";
import { ouvrirWiki } from "./navigation";

// ═══════════════ Encart « Ce que dit le wiki » (lot 3) ═══════════════
//  À poser dans un ticket :
//     <WikiLies token={token} type="ticket" id={ticketId} categorie={ticket.categorie} />
//  Deux sources, volontairement limitées à ce qui est explicite :
//   1. les pages qui citent #ticket:<id> — enregistrées depuis le lot 1 ;
//   2. les procédures publiées de la catégorie Modération marquées « à lire ».
//  Aucun appel IA, aucune recherche floue : un encart qui se trompe serait
//  pire qu'un encart absent.
export function WikiLies({ token, type, id, categorie }) {
  const api = useRef(wikiApi(token)).current;
  const [liees, setLiees] = useState([]);
  const [procedures, setProcedures] = useState([]);

  useEffect(() => {
    let vivant = true;
    if (!id) return undefined;
    fetch(`${API_BASE}/api/wiki/liens/${type}/${id}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => { if (vivant) setLiees(Array.isArray(d) ? d : []); })
      .catch(() => {});
    // Procédures de modération à connaître (uniquement pour les tickets)
    if (type === "ticket") {
      api.liste("categorie=moderation&statut=publie")
        .then((d) => { if (vivant) setProcedures((Array.isArray(d) ? d : []).filter((p) => p.a_lire).slice(0, 3)); })
        .catch(() => {});
    }
    return () => { vivant = false; };
  }, [type, id, api, token]);

  const pages = [
    ...liees.map((p) => ({ ...p, motif: "cite ce ticket" })),
    ...procedures.filter((p) => !liees.some((l) => l.slug === p.slug)).map((p) => ({ ...p, motif: "procédure à connaître" })),
  ];
  if (pages.length === 0) return null;

  return (
    <div style={{ background: THEME.purpleDim, border: `1px solid ${THEME.purple}`, borderRadius: 8, padding: "10px 14px", marginBottom: 16 }}>
      <div style={{ color: THEME.purple, fontSize: 11, fontWeight: 700, marginBottom: 8 }}>📚 CE QUE DIT LE WIKI</div>
      {pages.map((p) => (
        <div key={p.slug} onClick={() => ouvrirWiki({ type: "page", slug: p.slug })}
          style={{ background: THEME.panel, borderRadius: 6, padding: "8px 12px", marginBottom: 6, cursor: "pointer" }}
          onMouseEnter={(e) => (e.currentTarget.style.background = THEME.surface)}
          onMouseLeave={(e) => (e.currentTarget.style.background = THEME.panel)}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <span style={{ color: THEME.text, fontSize: 12.5, fontWeight: 600 }}>
              {wCat(p.categorie).icone} {p.titre}
            </span>
            <span style={{ color: THEME.textDim, fontSize: 10.5 }}>{p.motif}</span>
          </div>
          {p.resume && <div style={{ color: THEME.textMuted, fontSize: 11.5, marginTop: 3 }}>{p.resume}</div>}
        </div>
      ))}
    </div>
  );
}
